import type { SectionLocale } from '../types'

export const FAQ_LOCALE: SectionLocale = [
  [
    'faq_delete_question_title',
    {
      ru: 'Удалить вопрос?',
      en: 'Delete question?',
    },
  ],
  [
    'faq_delete_question_message',
    {
      ru: 'Вопрос пропадет из списка FAQ и его нельзя будет восстановить',
      en: 'The question will be removed from the FAQ list and cannot be restored',
    },
  ],
  [
    'faq_delete_question_error',
    {
      ru: 'Не удалось удалить вопрос. Попробуйте ещё раз.',
      en: 'Failed to delete the question. Please try again.',
    },
  ],
  [
    'faq_delete_question_success',
    {
      ru: 'Вопрос удалён',
      en: 'Question deleted',
    },
  ],
  [
    'faq_back_to_list',
    {
      ru: 'Назад к FAQ',
      en: 'Back to FAQ',
    },
  ],
  [
    'faq_page_description',
    {
      ru: 'Мы собрали ответы на частые вопросы о работе, документах, банковских аккаунтах и т.д. Если вы не нашли ответа на свой вопрос, то',
      en: 'We have collected answers to frequently asked questions about work, documents, bank accounts, etc. If you did not find an answer to your question,',
    },
  ],
  [
    'faq_page_description_link',
    {
      ru: 'напишите нам',
      en: 'contact us',
    },
  ],
  [
    'faq_list_empty',
    {
      ru: 'Пока нет вопросов',
      en: 'No questions yet',
    },
  ],
  [
    'faq_list_error',
    {
      ru: 'Не удалось загрузить список вопросов. Попробуйте обновить страницу.',
      en: 'Failed to load the question list. Please refresh the page.',
    },
  ],
  [
    'faq_add_item',
    {
      ru: 'Добавить вопрос',
      en: 'Add question',
    },
  ],
  [
    'faq_edit_item',
    {
      ru: 'Редактировать',
      en: 'Edit',
    },
  ],
  [
    'faq_delete_item',
    {
      ru: 'Удалить',
      en: 'Delete',
    },
  ],
  [
    'faq_breadcrumb_add',
    {
      ru: 'Добавление',
      en: 'Add',
    },
  ],
  [
    'faq_breadcrumb_edit',
    {
      ru: 'Редактирование',
      en: 'Edit',
    },
  ],
  [
    'faq_create_page_title',
    {
      ru: 'FAQ — добавление вопроса',
      en: 'FAQ — add question',
    },
  ],
  [
    'faq_edit_page_title',
    {
      ru: 'FAQ — редактирование вопроса',
      en: 'FAQ — edit question',
    },
  ],
  [
    'faq_item_not_found',
    {
      ru: 'Вопрос не найден',
      en: 'Question not found',
    },
  ],
  [
    'faq_editor_title',
    {
      ru: 'Вопрос',
      en: 'Question',
    },
  ],
  [
    'faq_editor_title_placeholder',
    {
      ru: 'Укажите вопрос',
      en: 'Enter the question',
    },
  ],
  [
    'faq_submit_add',
    {
      ru: 'Добавить',
      en: 'Add',
    },
  ],
  [
    'faq_create_success',
    {
      ru: 'Вопрос успешно добавлен',
      en: 'Question added successfully',
    },
  ],
  [
    'faq_update_success',
    {
      ru: 'Вопрос успешно сохранён',
      en: 'Question saved successfully',
    },
  ],
  [
    'faq_editor_content_required',
    {
      ru: 'Укажите ответ на вопрос',
      en: 'Enter the answer',
    },
  ],
  [
    'faq_editor_content_too_short',
    {
      ru: 'Ответ слишком короткий',
      en: 'Answer is too short',
    },
  ],
  [
    'faq_editor_content_too_long',
    {
      ru: 'Ответ слишком длинный',
      en: 'Answer is too long',
    },
  ],
  [
    'faq_editor_toolbar',
    {
      ru: 'Панель форматирования ответа',
      en: 'Answer formatting toolbar',
    },
  ],
]
